module.exports = __webpack_public_path__ + "media/images/classpoints/brands/CP-5fac95ec4839382bc42b7f007b3601d3.svg";